import { FontAwesomeIcon, Icon } from "assets/icons";
import { USER_PERMISSIONS } from "config/constants";
import AgentTabs from "features/Agent/List";
import ConsultRequestDetail from "pages/App/ConsultRequest/Detail";
import ConsultRequestList from "pages/App/ConsultRequest/List";
import SellerApprove from "./Approve";
import CreateContractScreen from "./Contract/Create";
import DetailContractScreen from "./Contract/Detail";
import ListContractScreen from "./Contract/List";
import CreateSeller from "./Create";
import SellerDetail from "./Detail";
import SellerGroupDetail from "./SellerGroup/Detail";
import SellerGroupList from "./SellerGroup/List";
import SellerUpdate from "./Update";

const consultRequestChildren = [
  {
    key: "consult-request-list",
    title: "v2.consultRequest.menu",
    path: "/consult-request",
    component: ConsultRequestList,
    exact: true,
  },
];
const consultRequestRoutes = [
  {
    key: "consult-request-detail",
    path: "/consult-request/detail/:id",
    component: ConsultRequestDetail,
    exact: true,
  },
];

const router = [
  {
    key: "seller",
    title: "common.seller",
    icon: <FontAwesomeIcon icon={Icon.faUserFriends} />,
    permissions: [USER_PERMISSIONS.SELLER_VIEW],
    children: [
      {
        key: "seller-list",
        title: "common.sellerList",
        path: "/seller",
        component: AgentTabs,
        exact: true,
      },
      {
        key: "seller-group",
        title: "common.groupCustomer",
        path: "/seller-group",
        component: SellerGroupList,
        exact: true,
      },
      {
        key: "list-contract",
        title: "Hợp đồng",
        path: "/list-contract",
        component: ListContractScreen,
        exact: true,
      },
      ...consultRequestChildren,
    ],
  },
  ...consultRequestRoutes,
  {
    key: "seller-create",
    path: "/seller/create",
    component: CreateSeller,
    exact: true,
  },
  {
    key: "seller-detail",
    path: "/seller/detail/:id",
    component: SellerDetail,
    exact: true,
  },
  {
    key: "seller-update",
    path: "/seller/update/:id",
    component: SellerUpdate,
    exact: true,
  },
  {
    key: "seller-approve",
    path: "/seller/:id?/approve/potential-customer/:potentialCustomerId?",
    component: SellerApprove,
    exact: true,
  },
  {
    key: "seller-group-detail",
    path: "/seller-group/detail/:id",
    component: SellerGroupDetail,
    exact: true,
  },
  {
    key: "contract-create",
    path: "/contract/create",
    component: CreateContractScreen,
    exact: true,
  },
  {
    key: "contract-create",
    path: "/contract/detail/:id",
    component: DetailContractScreen,
    exact: true,
  },
];

export default router;
